import React, { useContext, useEffect, useRef, useState } from 'react'
import { GrLocation, GrMenu } from "react-icons/gr";
import InputGroup from '../../components/Input/InputGroup';
import { IoIosCloseCircleOutline, IoIosSearch } from 'react-icons/io';
import { IoFilterSharp } from 'react-icons/io5';
import SuperAdminCard from '../../components/Cards/SuperAdminCard';
import ProfessionalDetailedView from './Resuable_Comp/ProfessionalDetailedView';
import SuperAdminContext from '../../hooks/SuperAdminContext';
import images from '../../utils/images';
import { HiOutlineBriefcase } from 'react-icons/hi2';
import SuperAdminPagination from './Resuable_Comp/SuperAdminPagination';
import ProfessionalFilter from './Resuable_Comp/ProfessionalFilter';
import toast from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { handleReset } from 'Actions/commonAction/milleSearchFilterActions';
import { reset_all_states_to_default } from 'Slices/commonSlices/milleSearchFilter';
import { createSelector } from '@reduxjs/toolkit';

const SuperAdminProfessional = () => {
    //Redux slice picker
    const selectmilleSearchStates = (state) => state.milleSearchStates;
    const selectMemoizedStates = createSelector(
        [selectmilleSearchStates],
        (milleSearchStates) => ({ milleSearchStates })
    );
    const { milleSearchStates } = useSelector(selectMemoizedStates);
    //

    const containerRef = useRef(null);
    const dispatch = useDispatch();
    const {
        currentPage,
        setMinimumDeviceCards,
        professionalCardsDupli,
        initialGlow, getAdminDashboard,
        selectedData, paginationTotalCount,
        setCurrentPage, professionalLocationConvertion,
        professionalPlanConvertion,
        professionalSkillConvertion,
        setProfessionalApplyFilterCount,
        setProfessionalApplyFilterObject, setProfessionalSearch,
        professionalFilter, setProfessionalFilter,
        professionalPagination,
        setInitialglow,
        superAdminProfessionalSearch, setsuperAdminProfessionalSearch,
        profmellieSearchSkills, setProfMellieSearchSkills,
        profmellieSearchLocations, setProfMellieSearchLocations,
        profmellieSearchPlans, setProfMellieSearchPlans,
        setProfessionalSortBy, isMilleSearchFiltered, setIsMilleSearchFiltered,
        isSearched, setIsSearched, handleAdminProfessionalMeilisearch,
        professionalGender, professionalIndustrySector, setProfessionalIndustrySector,
        professionalJobType, professionalModeOfCommunication, setProfessionalModeOfCommunication,
        professionalSector, setProfessionalSector,
        professionalRelocate, professionalLocPref, professionalFunctionalSpeci, setProfessionalFunctionalSpeci,
        professionalSearchType, setProfessionalSearchType
    } = useContext(SuperAdminContext);

    const [sortBy, setSortBy] = useState('Date Latest');
    const [professionalFilterGender, setProfessionalFilterGender] = useState([]);
    const [professionalFilterIndustrySector, setProfessionalFilterIndustrySector] = useState([]);
    const [professionalFilterJobType, setProfessionalFilterJobType] = useState([]);
    const [professionalFilterModeOfCommunication, setProfessionalFilterModeOfCommunication] = useState([]);
    const [professionalFilterSector, setProfessionalFilterSector] = useState([]);
    const [professionalFilterRelocate, setProfessionalFilterRelocate] = useState([]);
    const [professionalFilterLocPref, setProfessionalFilterLocPref] = useState([]);
    const [professionalFilterFunctionalSpeci, setProfessionalFilterFunctionalSpeci] = useState([]);
    const [selectedProfilePercentage, setSelectedProfilePercentage] = useState([]);
    const a = [1, 2, 3, 4, 5, 6, 7]
    const profilePercentageData = [
        { value: 1, label: '0% - 30%', endpointVal: '0-30' },
        { value: 2, label: '30% - 60%', endpointVal: '30-60' },
        { value: 3, label: '60% - 100%', endpointVal: '60-100' },
        { value: 4, label: '30% - 100%', endpointVal: '30-100' }
    ]

    useEffect(() => {
        setInitialglow(true);
        setMinimumDeviceCards(false);
        setCurrentPage(0);
        setProfessionalSearch("");
        getAdminDashboard();
        setProfessionalSortBy('')
        dispatch(handleReset())
        setSortBy('Date Latest')
        setSelectedProfilePercentage([])
        setIsMilleSearchFiltered(false)
        setIsSearched(false)
    }, [])

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [professionalCardsDupli])

    const handlekeydown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (superAdminProfessionalSearch) {
                setProfessionalSortBy('')
                setSortBy('Date Latest')
                setCurrentPage(0)
                setIsSearched(true)

                var a = profmellieSearchSkills.map((v) => v.label)
                var c = profmellieSearchPlans.map((v) => v.label)
                var gender = professionalFilterGender.map((v) => v.label)
                var industry_sector = professionalFilterIndustrySector.map((v) => v.label)
                var job_type = professionalFilterJobType.map((v) => v.label)
                var sector = professionalFilterSector.map((v) => v.label)
                var willing_to_relocate = professionalFilterRelocate.map((v) => v.label)
                var mode_of_communication = professionalFilterModeOfCommunication.map((v) => v.label)
                var functional_specification = professionalFilterFunctionalSpeci.map((v) => v.label)
                var location_preference = professionalFilterLocPref.map((v) => v.label)


                const locationConvertion = milleSearchStates?.location.map((v) => {
                    const originalVal = v.split(',')
                    const joinOriginalValue = originalVal.join('&&&&&')

                    return joinOriginalValue
                })


                let object;
                if (isMilleSearchFiltered) {
                    object = {
                        skills: a,
                        location: locationConvertion,
                        gender,
                        industry_sector,
                        job_type,
                        sector,
                        willing_to_relocate,
                        mode_of_communication,
                        functional_specification,
                        location_preference,
                        plan: c[0] === "All" ? [] : c,
                        profile_percentage: selectedProfilePercentage[0]?.endpointVal || "",
                        search_text: superAdminProfessionalSearch,
                    }
                } else {
                    object = {
                        skills: [],
                        location: [],
                        plan: [],
                        gender: [],
                        industry_sector: [],
                        job_type: [],
                        sector: [],
                        willing_to_relocate: [],
                        mode_of_communication: [],
                        functional_specification: [],
                        location_preference: [],
                        profile_percentage: "",
                        search_text: superAdminProfessionalSearch,
                    }
                }

                if (professionalSearchType !== 'Text search') object.flag = ""
                if (professionalSearchType !== 'Text search') object.pagination_flag = ""

                setProfessionalApplyFilterObject(object);
                handleAdminProfessionalMeilisearch(object)
            } else {
                toast.error("search field is empty")
            }
        }
    };

    const handleSearchInput = (e) => {
        setsuperAdminProfessionalSearch(e.target.value)
    }

    const handleSortingFilter = (sortValue) => {
        setSortBy(sortValue);
        setIsSearched(false)
        setIsMilleSearchFiltered(false)
        setProfessionalFilter(false);
        setProfessionalApplyFilterObject({});
        handleResetMellieSearcchFilter()

        switch (sortValue) {
            case "Date Latest":
                setProfessionalSortBy('')
                getAdminDashboard();
                setCurrentPage(0);
                break;

            case "Date Oldest":
                setProfessionalSortBy('by_date')
                getAdminDashboard(undefined, undefined, 'by_date');
                setCurrentPage(0);
                break;


            case "A-Z":
                setProfessionalSortBy('asc')
                getAdminDashboard(undefined, undefined, 'asc');
                setCurrentPage(0);
                break;

            case "Z-A":
                setProfessionalSortBy('desc')
                getAdminDashboard(undefined, undefined, 'desc');
                setCurrentPage(0);

                break;
            default:
                break;
        }
    }

    function handleResetMellieSearcchFilter() {
        setProfMellieSearchSkills([]);
        setProfMellieSearchLocations([]);
        setProfMellieSearchPlans([]);
        setSelectedProfilePercentage([]);
        setProfessionalFilterGender([]);
        setProfessionalFilterIndustrySector([]);
        setProfessionalFilterJobType([]);
        setProfessionalFilterModeOfCommunication([]);
        setProfessionalFilterSector([]);
        setProfessionalFilterRelocate([]);
        setProfessionalFilterLocPref([]);
        setProfessionalFilterFunctionalSpeci([]);
        setProfessionalApplyFilterCount(0);
        dispatch(reset_all_states_to_default())
    }

    useEffect(() => {
        var getFilterLength = profmellieSearchSkills.length + profmellieSearchLocations.length + profmellieSearchPlans.length
            + professionalFilterGender.length + professionalFilterIndustrySector.length + professionalFilterJobType.length
            + professionalFilterModeOfCommunication.length + professionalFilterSector.length + professionalFilterRelocate.length
            + professionalFilterLocPref.length + professionalFilterFunctionalSpeci.length;

        setProfessionalApplyFilterCount(getFilterLength);
    }, [profmellieSearchSkills, milleSearchStates?.location, profmellieSearchPlans, professionalFilterGender, professionalFilterIndustrySector, professionalFilterJobType,
        professionalFilterModeOfCommunication, professionalFilterSector, professionalFilterRelocate, professionalFilterLocPref, professionalFilterFunctionalSpeci
    ])

    const handleMellieSearch = (searchType) => {
        setCurrentPage(0);
        setProfessionalSortBy('')
        setSortBy('Date Latest')

        if (searchType === "ApplyFilter") {
            var getFilterLength = profmellieSearchSkills.length + profmellieSearchLocations.length + profmellieSearchPlans.length
                + professionalFilterGender.length + professionalFilterIndustrySector.length + professionalFilterJobType.length
                + professionalFilterModeOfCommunication.length + professionalFilterSector.length + professionalFilterRelocate.length
                + professionalFilterLocPref.length + professionalFilterFunctionalSpeci.length + selectedProfilePercentage.length
                + milleSearchStates?.location?.length

            setProfessionalApplyFilterCount(getFilterLength);

            if (getFilterLength > 0) {
                setIsMilleSearchFiltered(true)

                var a = profmellieSearchSkills.map((v) => v.label)
                var c = profmellieSearchPlans.map((v) => v.label)
                var gender = professionalFilterGender.map((v) => v.label)
                var industry_sector = professionalFilterIndustrySector.map((v) => v.label)
                var job_type = professionalFilterJobType.map((v) => v.label)
                var sector = professionalFilterSector.map((v) => v.label)
                var willing_to_relocate = professionalFilterRelocate.map((v) => v.label)
                var mode_of_communication = professionalFilterModeOfCommunication.map((v) => v.label)
                var functional_specification = professionalFilterFunctionalSpeci.map((v) => v.label)
                var location_preference = professionalFilterLocPref.map((v) => v.label)

                const locationConvertion = milleSearchStates?.location.map((v) => {
                    const originalVal = v.split(',')
                    const joinOriginalValue = originalVal.join('&&&&&')

                    return joinOriginalValue
                })

                let object;
                if (isSearched) {
                    object = {
                        skills: a,
                        location: locationConvertion,
                        gender,
                        industry_sector,
                        job_type,
                        sector,
                        willing_to_relocate,
                        mode_of_communication,
                        functional_specification,
                        location_preference,
                        plan: c[0] === "All" ? [] : c,
                        profile_percentage: selectedProfilePercentage[0]?.endpointVal || "",
                        search_text: superAdminProfessionalSearch
                    }

                    if (professionalSearchType !== 'Text search') object.flag = "filter_in_search"
                    if (professionalSearchType !== 'Text search' && !isSearched) object.pagination_flag = ""
                    if (professionalSearchType !== 'Text search' && isSearched) object.pagination_flag = "first_page"
                } else {
                    object = {
                        skills: a,
                        location: locationConvertion,
                        gender,
                        industry_sector,
                        job_type,
                        sector,
                        willing_to_relocate,
                        mode_of_communication,
                        functional_specification,
                        location_preference,
                        plan: c[0] === "All" ? [] : c,
                        profile_percentage: selectedProfilePercentage[0]?.endpointVal || "",
                        search_text: ""
                    }

                    if (professionalSearchType !== 'Text search') object.flag = ""
                    if (professionalSearchType !== 'Text search' && !isSearched) object.pagination_flag = ""
                    if (professionalSearchType !== 'Text search' && isSearched) object.pagination_flag = "first_page"

                }
                setProfessionalApplyFilterObject(object);
                handleAdminProfessionalMeilisearch(object)
                setProfessionalFilter(false);
            } else {
                toast.error("fields are empty")
            }
        }
    }

    function clickSearchIcon() {
        setProfessionalSortBy('')
        setSortBy('Date Latest')
        setIsSearched(true)

        var a = profmellieSearchSkills.map((v) => v.label)
        var c = profmellieSearchPlans.map((v) => v.label)
        var gender = professionalFilterGender.map((v) => v.label)
        var industry_sector = professionalFilterIndustrySector.map((v) => v.label)
        var job_type = professionalFilterJobType.map((v) => v.label)
        var sector = professionalFilterSector.map((v) => v.label)
        var willing_to_relocate = professionalFilterRelocate.map((v) => v.label)
        var mode_of_communication = professionalFilterModeOfCommunication.map((v) => v.label)
        var functional_specification = professionalFilterFunctionalSpeci.map((v) => v.label)
        var location_preference = professionalFilterLocPref.map((v) => v.label)
        const locationConvertion = milleSearchStates?.location.map((v) => {
            const originalVal = v.split(',')
            const joinOriginalValue = originalVal.join('&&&&&')

            return joinOriginalValue
        })

        let object;
        if (isMilleSearchFiltered) {
            object = {
                skills: a,
                location: locationConvertion,
                gender,
                industry_sector,
                job_type,
                sector,
                willing_to_relocate,
                mode_of_communication,
                functional_specification,
                location_preference,
                plan: c[0] === "All" ? [] : c,
                profile_percentage: selectedProfilePercentage[0]?.endpointVal || "",
                search_text: superAdminProfessionalSearch
            }
        } else {
            object = {
                skills: [],
                location: [],
                plan: [],
                gender: [],
                industry_sector: [],
                job_type: [],
                sector: [],
                willing_to_relocate: [],
                mode_of_communication: [],
                functional_specification: [],
                location_preference: [],
                profile_percentage: "",
                search_text: superAdminProfessionalSearch
            }
        }

        if (professionalSearchType !== 'Text search') object.flag = ""
        if (professionalSearchType !== 'Text search') object.pagination_flag = ""
        setProfessionalApplyFilterObject(object);
        handleAdminProfessionalMeilisearch(object)
    }

    function handle_clear_user_searches(clear_params) {
        setCurrentPage(0)
        if ((!isSearched && !isMilleSearchFiltered) || (clear_params === "search" && !isMilleSearchFiltered) || (clear_params === "clear filter" && !isSearched)) {
            if (clear_params === "search") {
                setIsSearched(false)
                setsuperAdminProfessionalSearch('')
            }

            if (clear_params === "clear filter") {
                setIsMilleSearchFiltered(false)
                handleResetMellieSearcchFilter()
            }

            getAdminDashboard();
            return
        }

        let object;
        if (clear_params === "search") {
            setIsSearched(false)
            setsuperAdminProfessionalSearch('')

            var a = profmellieSearchSkills.map((v) => v.label)
            var c = profmellieSearchPlans.map((v) => v.label)
            var gender = professionalFilterGender.map((v) => v.label)
            var industry_sector = professionalFilterIndustrySector.map((v) => v.label)
            var job_type = professionalFilterJobType.map((v) => v.label)
            var sector = professionalFilterSector.map((v) => v.label)
            var willing_to_relocate = professionalFilterRelocate.map((v) => v.label)
            var mode_of_communication = professionalFilterModeOfCommunication.map((v) => v.label)
            var functional_specification = professionalFilterFunctionalSpeci.map((v) => v.label)
            var location_preference = professionalFilterLocPref.map((v) => v.label)
            const locationConvertion = milleSearchStates?.location.map((v) => {
                const originalVal = v.split(',')
                const joinOriginalValue = originalVal.join('&&&&&')

                return joinOriginalValue
            })

            if (isMilleSearchFiltered) {
                object = {
                    skills: a,
                    location: locationConvertion,
                    gender,
                    industry_sector,
                    job_type,
                    sector,
                    willing_to_relocate,
                    mode_of_communication,
                    functional_specification,
                    location_preference,
                    plan: c[0] === "All" ? [] : c,
                    profile_percentage: selectedProfilePercentage[0]?.endpointVal || "",
                    search_text: ""
                }
            } else {
                object = {
                    skills: [],
                    location: [],
                    plan: [],
                    gender: [],
                    industry_sector: [],
                    job_type: [],
                    sector: [],
                    willing_to_relocate: [],
                    mode_of_communication: [],
                    functional_specification: [],
                    location_preference: [],
                    profile_percentage: "",
                    search_text: ""
                }
            }
        } else {
            setIsMilleSearchFiltered(false)
            object = {
                skills: [],
                location: [],
                plan: [],
                gender: [],
                industry_sector: [],
                job_type: [],
                sector: [],
                willing_to_relocate: [],
                mode_of_communication: [],
                functional_specification: [],
                location_preference: [],
                profile_percentage: "",
                search_text: isSearched ? superAdminProfessionalSearch : ''
            }
            handleResetMellieSearcchFilter()
            setProfessionalFilter(false);
        }

        if (professionalSearchType !== 'Text search') object.flag = ""
        if (professionalSearchType !== 'Text search') object.pagination_flag = ""
        setProfessionalApplyFilterObject(object);
        handleAdminProfessionalMeilisearch(object)
    }

    function toogleSearch(toogle_as) {
        setProfessionalSearchType(toogle_as)
        setInitialglow(true);
        setMinimumDeviceCards(false);
        setCurrentPage(0);
        setProfessionalSearch("");
        getAdminDashboard();
        setProfessionalSortBy('')
        dispatch(handleReset())
        setSortBy('Date Latest')
        setSelectedProfilePercentage([])
        setIsMilleSearchFiltered(false)
        setIsSearched(false)
        handleResetMellieSearcchFilter()
        setsuperAdminProfessionalSearch('')
    }

    return (
        <>
            <div className="col-12 col-xxl-10 superAdmin-rightSide-total-height overflow-hidden">
                <div className="col-12 superAdmin-rightSide-Component-name-height ">
                    <div className="container-fluid px-lg-4 h-100">
                        <div className="row align-items-center h-100 ">
                            <div className="col-6">
                                <h5>Professional</h5>
                            </div>

                            <div className="col-6 text-end d-xxl-none">
                                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#superAdminSidebar" aria-controls="superAdminSidebar">
                                    <GrMenu className='fs-4' />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 superAdmin-rightSide-Component-content-height placeholder-glow">
                    <div className="container-fluid px-lg-4 h-100">
                        <div className="row h-100">
                            <div className="col-12 col-lg-4 h-100 py-3">
                                <div className="row superAdmin-professional-page-functions">
                                    <div className="col-12 col-md-12 col-lg-12 d-flex flex-wrap">
                                        <div className="col-6 pe-1">
                                            {
                                                initialGlow ?
                                                    <div className='placeholder w-100 rounded-2 py-3'></div>
                                                    :
                                                    <button
                                                        type='button'
                                                        className={`btn text-center w-100 ${professionalSearchType === "Text search" ? "btn-brand-color" : "border-brand-color"}`}
                                                        value={professionalSearchType}
                                                        onClick={() => toogleSearch('Text search')}
                                                    >
                                                        Text search
                                                    </button>
                                            }
                                        </div>
                                        <div className="col-6 ps-1">
                                            {
                                                initialGlow ?
                                                    <div className='placeholder w-100 rounded-2 py-3'></div>
                                                    :
                                                    <button
                                                        type='button'
                                                        className={`btn text-center w-100 ${professionalSearchType === "AI search" ? "btn-brand-color" : "border-brand-color"}`}
                                                        value={professionalSearchType}
                                                        onClick={() => toogleSearch('AI search')}
                                                    >
                                                        AI search
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                    {/* search bar  */}
                                    <div className="col-12 col-md-12 col-lg-12">
                                        {
                                            initialGlow ?
                                                <div className='placeholder w-100 rounded-2 py-3'></div>
                                                :
                                                <div className="d-flex position-relative">
                                                    <InputGroup
                                                        className="home-search-icon fs-5"
                                                        reIcons={<IoIosSearch />}
                                                    />

                                                    <input
                                                        type="text"
                                                        className='form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border'
                                                        placeHolder="Search by name,location,skills"
                                                        ariaLabel="default input example"
                                                        testId="searchResult"
                                                        value={superAdminProfessionalSearch}
                                                        onChange={handleSearchInput}
                                                        onKeyDown={handlekeydown}
                                                        disabled={initialGlow || professionalPagination}
                                                    />

                                                    {
                                                        superAdminProfessionalSearch && !(initialGlow || professionalPagination) ?
                                                            <div className='searchButtonClick-superAdmin ' title='Search' onClick={() => clickSearchIcon()}>
                                                                <IoIosSearch />
                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    <div className='clearButtonClick-superAdmin' title='Clear' onClick={() => handle_clear_user_searches("search")}>
                                                        <MdClear />
                                                    </div>
                                                </div>
                                        }
                                    </div>

                                    {/* filter modal  */}
                                    <div className="col-12 col-sm-6 col-lg-12">
                                        {
                                            initialGlow ?
                                                <div className='placeholder w-100 rounded-2 py-3'></div>
                                                :
                                                <div className="card rounded-3 border-0 w-100">
                                                    <div className="card-body p-0 cursorPointer ">
                                                        <div className="d-flex flex-wrap align-items-center py-2 w-100 " onClick={() => setProfessionalFilter(!professionalFilter)}>
                                                            <div className="col-2 col-lg-1 text-center p-0">
                                                                <IoFilterSharp className='fs-4 ' />
                                                            </div>
                                                            <div className="col-4">
                                                                <p className="mb-0 ps-2 w-100 superAdmin-filter-size-title">
                                                                    Filter
                                                                </p>
                                                            </div>
                                                            <div className="col-6 col-lg-7 text-end">
                                                                {
                                                                    isMilleSearchFiltered ?
                                                                        <button type="button" className="btn btn-transparent border border-brand-color candidate-right-side-btn me-3"
                                                                            onClick={() => handle_clear_user_searches("clear filter")}
                                                                        >
                                                                            Clear Filter
                                                                        </button>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className={`${professionalFilter && !initialGlow && !professionalPagination ? "employer-filter-box-sprAdmin-professional rounded-4 shadow" : "d-none"}`}>
                                                            <div className="h-100 filter-closet">
                                                                <div className="d-flex flex-wrap align-items-center p-3 pb-2 pe-1 sticky-top border-bottom bg-white  start-0 end-0 top-0 bottom-0 w-100 rounded-top-4">
                                                                    <div className="col">
                                                                        <h6 className="m-0 fw-bold">Filter</h6>
                                                                    </div>
                                                                    <div className="col text-end">
                                                                        <button className="btn btn-sm border-0">
                                                                            <IoIosCloseCircleOutline
                                                                                className="fs-4"
                                                                                onClick={() => setProfessionalFilter(!professionalFilter)}
                                                                            />
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {/* employer-filter-box body */}
                                                                <ProfessionalFilter
                                                                    professionalGender={professionalGender}
                                                                    professionalFilterGender={professionalFilterGender}
                                                                    setProfessionalFilterGender={setProfessionalFilterGender}

                                                                    professionalIndustrySector={professionalIndustrySector}
                                                                    professionalFilterIndustrySector={professionalFilterIndustrySector}
                                                                    setProfessionalIndustrySector={setProfessionalIndustrySector}
                                                                    setProfessionalFilterIndustrySector={setProfessionalFilterIndustrySector}

                                                                    professionalJobType={professionalJobType}
                                                                    professionalFilterJobType={professionalFilterJobType}
                                                                    setProfessionalFilterJobType={setProfessionalFilterJobType}

                                                                    professionalSector={professionalSector}
                                                                    setProfessionalSector={setProfessionalSector}
                                                                    professionalFilterSector={professionalFilterSector}
                                                                    setProfessionalFilterSector={setProfessionalFilterSector}

                                                                    professionalModeOfCommunication={professionalModeOfCommunication}
                                                                    setProfessionalModeOfCommunication={setProfessionalModeOfCommunication}
                                                                    professionalFilterModeOfCommunication={professionalFilterModeOfCommunication}
                                                                    setProfessionalFilterModeOfCommunication={setProfessionalFilterModeOfCommunication}

                                                                    professionalRelocate={professionalRelocate}
                                                                    professionalFilterRelocate={professionalFilterRelocate}
                                                                    setProfessionalFilterRelocate={setProfessionalFilterRelocate}

                                                                    professionalLocPref={professionalLocPref}
                                                                    professionalFilterLocPref={professionalFilterLocPref}
                                                                    setProfessionalFilterLocPref={setProfessionalFilterLocPref}

                                                                    professionalFunctionalSpeci={professionalFunctionalSpeci}
                                                                    setProfessionalFunctionalSpeci={setProfessionalFunctionalSpeci}
                                                                    professionalFilterFunctionalSpeci={professionalFilterFunctionalSpeci}
                                                                    setProfessionalFilterFunctionalSpeci={setProfessionalFilterFunctionalSpeci}

                                                                    skillData={professionalSkillConvertion}
                                                                    locationData={professionalLocationConvertion}
                                                                    planData={professionalPlanConvertion}

                                                                    mellieSearchSkills={profmellieSearchSkills}
                                                                    setMellieSearchSkills={setProfMellieSearchSkills}
                                                                    mellieSearchLocations={profmellieSearchLocations}
                                                                    mellieSearchPlans={profmellieSearchPlans}
                                                                    setMellieSearchPlans={setProfMellieSearchPlans}
                                                                    handleMellieSearch={handleMellieSearch}
                                                                    setProfessionalFilter={setProfessionalFilter}
                                                                    profilePercentageData={profilePercentageData}
                                                                    selectedProfilePercentage={selectedProfilePercentage}
                                                                    setSelectedProfilePercentage={setSelectedProfilePercentage}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </div>

                                    {/* sorting  */}
                                    <div className="col-12 col-sm-6 col-lg-12">
                                        {
                                            initialGlow ?
                                                <div className='placeholder w-100 rounded-2 py-3'></div>
                                                :
                                                <div className="dropdown employer-custom-dropdown">
                                                    <button
                                                        className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <span className="fw-bold">Sort by :</span>
                                                        <span className="text-secondary ps-3">
                                                            {sortBy}
                                                        </span>
                                                    </button>
                                                    <ul className="dropdown-menu w-100 border-0 shadow">
                                                        <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Date Latest")}>
                                                            Date Latest
                                                        </li>
                                                        <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Date Oldest")}>
                                                            Date Oldest
                                                        </li>
                                                        <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("A-Z")}>
                                                            A-Z
                                                        </li>
                                                        <li className="dropdown-item p-2 ps-3" onClick={() => handleSortingFilter("Z-A")}>
                                                            Z-A
                                                        </li>
                                                    </ul>
                                                </div>
                                        }
                                    </div>

                                    <div className="col-12 col-sm-6 col-lg-12">
                                        {
                                            initialGlow || professionalPagination ?
                                                <div className='placeholder w-100 rounded-2 py-3'></div>
                                                :
                                                <p className='showing-results text-secondary mb-0 py-2'>
                                                    {
                                                        professionalCardsDupli.length > 0 ?
                                                            paginationTotalCount > 10 ?
                                                                // `Showing : ${(currentPage * 10) + 1}-${(currentPage * 10) + professionalCardsDupli.length} of ${formatNumber(paginationTotalCount)} profiles`
                                                                `Showing : ${(currentPage * 10) + 1}-${(currentPage * 10) + professionalCardsDupli.length} of ${paginationTotalCount} profiles`
                                                                :
                                                                `Showing : 1-${professionalCardsDupli.length} of ${professionalCardsDupli.length} profiles`
                                                            :
                                                            `Showing : 0 profiles`
                                                    }
                                                </p>
                                        }
                                    </div>
                                </div>

                                {/* candidates cards  */}
                                <div ref={containerRef} className={`${professionalCardsDupli.length > 0 ? "overflow-scroll" : ""} superAdmin-professional-page-cards`}>
                                    <div className={`${professionalCardsDupli.length > 0 ? "" : "h-100"} d-flex flex-wrap align-content-stretch justify-content-between pb-3`}>
                                        {
                                            initialGlow || professionalPagination ?
                                                a.map((value, index) => {
                                                    return (
                                                        <div className="col-12 col-sm-6 col-lg-12 p-2" key={index}>
                                                            <div className="card rounded-2 border-0 py-2">
                                                                <div className="d-flex flex-wrap w-100 p-3 pe-0">
                                                                    <div className="col-2 placeholder rounded-circle pe-none">
                                                                        <img
                                                                            src={""}
                                                                            width={48}
                                                                            height={48}
                                                                            className="opacity-0 d-block"
                                                                            alt="..."
                                                                        />
                                                                    </div>
                                                                    <div className="col-10">
                                                                        <div className="container-fluid">
                                                                            <p className='mb-0 pb-1 superAdmin-recommended-card-heading placeholder rounded-2 w-75 py-3 mb-1'></p>
                                                                            <p className="mb-0 superAdmin-recommended-card-sub-content mb-1">
                                                                                <span className="pe-2 placeholder rounded-2"><HiOutlineBriefcase /></span>
                                                                                <span className="placeholder rounded-2 w-25 py-2 ms-2"></span>
                                                                            </p>
                                                                            <p className="mb-0 superAdmin-recommended-card-sub-content">
                                                                                <span className="pe-2 placeholder rounded-2"><GrLocation /></span>
                                                                                <span className="placeholder rounded-2 w-25 py-2 ms-2"></span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                                :
                                                professionalCardsDupli.length > 0 ?
                                                    professionalCardsDupli.map((v, i) => {
                                                        return (
                                                            <div className='col-12 col-sm-6 col-lg-12 py-1 px-sm-2 px-lg-0' key={i}>
                                                                <div className="card mb-2 rounded-4 border-0 w-100 h-100">
                                                                    <div className="card-body p-0">
                                                                        <SuperAdminCard
                                                                            profile_image={v.profile_image}
                                                                            first_name={v.first_name}
                                                                            last_name={v.last_name}
                                                                            job_title={v.job_title}
                                                                            city={v.city}
                                                                            pricing_category={v.pricing_category}
                                                                            id={v.professional_id}
                                                                            handleSelectedData={selectedData}
                                                                            notes={v.expert_notes}
                                                                            recom_jobs={v.recommended_jobs}
                                                                            professional_id={v.professional_id}
                                                                            profile_percentage={v?.profile_percentage}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <div className="col-12 h-100 row align-items-center justify-content-center">
                                                        <img src={images.noRecordsFound} className="sprAdmin-NoRecord-img" alt="no data found" />
                                                    </div>
                                        }
                                    </div>

                                    {
                                        initialGlow || professionalPagination ?
                                            <div className="col-12 row justify-content-center">
                                                <div className="col-10 placeholder rounded-2 py-3"></div>
                                            </div>
                                            :
                                            paginationTotalCount > 10 ?
                                                <div className="mb-5 col-12">
                                                    <SuperAdminPagination />
                                                </div>
                                                :
                                                null
                                    }
                                </div>
                            </div>

                            {/* candidates detail view  */}
                            <div className="col-7 col-lg-8 py-3 h-100">
                                <ProfessionalDetailedView />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SuperAdminProfessional